export function getGroupingKey(item) {
    return `service_id_${item.service_id}__service_title_${item.service_title}`
}
